import axios from 'axios';

const localApi = axios.create({
    baseURL: 'https://api.painel.loeffa.com/v1/',
})

export default localApi;